<template>
  <div class="sm-700px">
    <div class="absolute insights-bg z-index--1 md:block lg:block hidden">
      <img
        src="@/assets/images/line/insig-line.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div>
    <div class="relative">
      <img
        src="@/assets/images/line/Vector 9.png"
        alt="lineimg"
        class="m-auto px-4"
      />
      <div class="lg:flex md:flex justify-center lg:pt-0 md:pt-0 sm-h70px">
        <div
          class="borderprimary bg-white lg:p-4 md:p-4 mob-pt-3 rounded-2xl lg:w-2/5 md:w-9/12 w-1/2 m-auto absolute cust-top98 cust-reg-adjust"
        >
          <div class="bgcceff2 rounded-2xl">
            <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
              <p
                class="font-semibold text-black text-center fsize20 sm-fsize14"
              >
                Want to become a caregiver coach?
              </p>
              <div
                class="lg:pl-14 md:pl-14 lg:pt-0 md:pt-0 pt-4 items-center flex lg:justify-start md:justify-start justify-center"
              >
                <base-button
                  type="primary"
                  @click="
                    handleRoute('request-form', 'register-for-programmes')
                  "
                  class="py-2 px-8 text-base font-bold border-2 mt-2 md:mt-0 lg:mt-0 whitespacenowrap mx-auto md:w-auto lg:w-auto w-full"
                  >Register Now
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <img
      src="@/assets/images/coachnew/Frame 1000002208.png"
      class="right-0 sm-zindex9 cust-fix cursor-pointer sm-h120"
      alt="register"
      @click="handleRoute('request-form', 'register-for-programmes')"
    />

    <div class="w-full">
      <div class="lg:pb-0 md:pb-0 pb-0 lg:px-16 md:px-16 container mx-auto">
        <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8">
          <div
            class="w-full z-index1"
            v-for="item in podcasts"
            :key="item.objectId"
          >
            <div
              class="w-full bg-white h-470 sm-h350 cust-overflow-y-greys p-4 border-primary"
            >
              <!-- <img :src="item.image" alt="Grid" class="w-80 h-80 m-auto my-8" /> -->
              <div class="w-full">
                <h6
                  class="fsize22 sm-fsize20 py-4 font-bold text-primary text-center"
                >
                  {{ item.head }}
                </h6>
                <p
                  class="fsize16 sm-fsize14 leading-8 font-bold lg:my-8 md:my-8 text-center"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <img
          src="@/assets/images/coachnew/Polygon 9.png"
          class="left-0 absolute"
          alt="register"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      podcasts: [
        {
          head: "Why Family Caregivers?",
          // image: require("@/assets/images/coach/image 23.png"),
          name: "The role demands life-and-death decision-making skills, offers no formal vacation policy, training, or pay, and may compromise a person’s health, well-being and financial security. The intent is to create a support system for Caregivers to have access to high-quality  interventions designed to help them ease their caregiving journey.",
        },
        {
          head: "Why Coaches & Therapists?",
          // image: require("@/assets/images/coach/image 23.png"),
          name: "Certified Coaches and Therapists come with validated skills and personal values such as being of service to others, making a larger contribution to the world, and helping people to live their fullest potential. ",
        },
        {
          head: "Why You?",
          // image: require("@/assets/images/coach/image 23.png"),
          name: "Join this program if you align with our goal of creating a supportive ecosystem for a caregiver and would like to consult with family caregivers through our platform and, in addition, also extend your own business",
        },
      ],
    };
  },
  methods: {
    register() {
      window.open("https://forms.office.com/r/gsJAc4GPR7");
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
};
</script>
<style>
@media (max-width: 640px) {
  .sm-h70px {
    height: 70px;
  }
}
</style>
